export type ListingReducerProps = {
  address?: string;
  unit?: string;
  numUnits?: string;
  propertyType?: string;
  isRoomForRent?: boolean;
  isMultifamily?: boolean;
  customerId?: string;
  listingAlias?: string;
  isAddressEditable?: boolean;
  duplicateAccountListingAlias?: string | null;
};

export type ListingErrorsReducerProps = {
  type: keyof ListingReducerProps | 'listing';
  payload:
    | string
    | JSX.Element
    | Array<string | JSX.Element>
    | Record<string, string | JSX.Element | Array<string | JSX.Element>>;
};

export type ListingErrorsReducerState = Partial<
  Record<keyof ListingReducerProps | 'listing', string | JSX.Element | Array<string | JSX.Element>>
>;

export const listing = (
  state: ListingReducerProps,
  action: { type: keyof ListingReducerProps | 'UPDATE_ALL'; payload: unknown },
) => {
  const { type, payload } = action;

  switch (action.type) {
    case 'UPDATE_ALL':
      return { ...state, ...(payload as Record<string, unknown>) };
    default:
      return { ...state, [type]: payload };
  }
};

export const listingErrors = (state: ListingErrorsReducerState, action: ListingErrorsReducerProps) => {
  const { type, payload } = action;

  if (type === 'listing') {
    return payload as ListingErrorsReducerState;
  }

  return { ...state, [type]: payload } as ListingErrorsReducerState;
};
